import React from "react";

export const mapSelectOptions = (options: any) => {
    return options.map((x: any, xIndex: number) =>
        <option key={xIndex} value={x}>
            {x.charAt(0).toUpperCase() + x.slice(1)}
        </option>)
}
